export default __webpack_public_path__ + "static/media/arrowToRight.c9d08e88.svg";